export type RawPolicyId = Buffer;

export type AssetName = Buffer;

export type MultiAsset<T> = Map<RawPolicyId, Map<AssetName, T>>;
// negInt64 = -9223372036854775808 .. -1
// posInt64 = 1 .. 9223372036854775807
// nonZeroInt64 = negInt64 / posInt64 ;

export type Mint = MultiAsset<bigint | number>;
